import { Component } from '@angular/core'

@Component({
  template: '<ftr-logout></ftr-logout>',
  standalone: false,
})
export class LogoutPage {}
